<h4 *ngIf="status == 0" class="status-bar preparing">{{'LIVE.WAITING' | translate}}</h4>
<h4 *ngIf="status == 1" class="status-bar ongoing">{{'LIVE.STARTED' | translate}}</h4>
<h4 *ngIf="status == 2" class="status-bar closed">{{'LIVE.CLOSED' | translate}}</h4>
